import * as actions from "../actions";
import * as constants from "./constants";

const fallbackSubscriptions = () => {
  return constants.subscriptions;
}

const subscriptions = (state = {
                        subscriptions: fallbackSubscriptions(),
                        hasSubscriptionToSearchAvailableTechnicians: false,
                        connectionError: null
                      }, action) => {
  switch (action.type) {
    case actions.SUBSCRIPTION_FETCHED:
      return {...state, 
        connectionError: null,
        subscriptions: action.subscriptions,
        hasSubscriptionToSearchAvailableTechnicians: action.subscriptions !== false && action.subscriptions.includes("search available technicians")};
    case actions.GET_SUBSCRIPTIONS_ERROR:
      return {...state, connectionError: action.error};
    default:
      return state;
  }
};

export default subscriptions;